import { Grid } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { UomText } from 'src/common/enumerations/unit-of-measure-type';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { useTranslation } from 'react-i18next';
import { manualVolumeStyles } from './manual-volume-styles';

const ManualVolumeItemWindow: React.FC<PriceCheckSellingProps> = (
  props: PriceCheckSellingProps,
): JSX.Element => {
  const classes = manualVolumeStyles();
  const { t } = useTranslation();

  const { longDescription, description, unitsOfMeasure, unitPrice, itemId } = props.itemData;

  return (
    <Grid
      item
      container
      direction='row'
      justifyContent='center'
      style={{ flex: 1 }}
      data-testid='manual-volume-get'
    >
      <Grid container className={`${classes.fitHeight} ${classes.topMargin}`}>
        <Grid item container className={classes.itemContent}>
          <Grid
            container
            className={`${classes.descriptionStyle} ${classes.descriptionWithPriceContainer}`}
          >
            <Grid item>
              <span
                className={classes.manualVolumeTitleHeader}
                data-testid='manual-volume-get-window-long-description'
              >
                {longDescription || description}
              </span>
            </Grid>
            <Grid
              item
              className={classes.unitPriceContainer}
              data-testid='manual-volume-get-window-quantity'
            >
              <span
                className={`${classes.manualVolumeTitleHeader} ${classes.manualVolumeTitle}`}
                data-testid={`manual-volume-unit-price`}
              >
                {unitPrice && convertCurrency(unitPrice)}
              </span>
              <span
                className={`${classes.quantityLinePieces} ${classes.quantityLineColor}`}
                data-testid='manual-volume-get-window-uom'
              >
                {unitsOfMeasure && `  / ${UomText[unitsOfMeasure]}`}
              </span>
            </Grid>
          </Grid>
          <Grid container className={classes.descriptionStyle}>
            <span
              className={`${classes.manualVolumeTitleHeader} ${classes.quantityLineColor}`}
              data-testid='manual-volume-get-window-itemId'
            >
              {itemId}
            </span>
          </Grid>
        </Grid>
      </Grid>
      <Grid item container justifyContent='center' className={classes.selfAlign}>
        <BaseButton
          className={classes.cancelButton}
          buttonType='white'
          onClick={props.onCancel}
          data-testid='manual-volume-cancel-button'
        >
          {t('Cancel')}
        </BaseButton>
      </Grid>
    </Grid>
  );
};

export interface PriceCheckSellingProps {
  itemData: IItemLookup;
  onCancel: () => void;
}

export default ManualVolumeItemWindow;
